import React from 'react';
import moment from 'moment';
import './CloneHistoryItem.css'

const CloneHistoryItem = ({ showCopyToDate, dateValue, handleSubmit, handleOnDateChange, handleToggleCopyToDate }) => {

  return (
    <div className="clone-history-item">
      {!showCopyToDate && <button className="btn btn-success" onClick={handleToggleCopyToDate}>Add New Month</button>}
      {showCopyToDate && (
      <form onSubmit={handleSubmit}>
          <input id="date" type="date" className="form-control" value={dateValue} onChange={handleOnDateChange} required />
          <input type="submit" className="btn btn-success" value="Save new month" />
      </form>
    )}
    </div>
  )
}

export default CloneHistoryItem;




// WEBPACK FOOTER //
// ./src/components/CloneHistoryItem/CloneHistoryItem.js